"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticationRequired = void 0;
const RouteInterceptor_1 = require("../RouteInterceptor");
const urlToLogin = (location) => {
    const nextPath = encodeURIComponent(`${location.pathname}${location.search}`);
    return new URL(`${location.origin}/spa/authentication/login?next=${nextPath}`).toString();
};
/**
 * Intercepts the route to check for authentication requirements.
 * If the session is missing, return the user to login with a next params
 * If we have a partial session but the flag for `forcePasswordChange` is missing, force them to change password first
 * it returns a redirect action to the appropriate login or password change URL.
 *
 * @category Interceptor
 *
 * @returns {TInterceptorFunction<{ session?: ISessionAdapter }>} A function that checks the session and returns a redirect action if necessary.
 */
const authenticationRequired = () => ({ context, location }) => {
    const redirectUrl = urlToLogin(location);
    if (context?.session?.user?.flags?.includes("forcePasswordChange")) {
        return {
            kind: RouteInterceptor_1.RouteAction.REDIRECT_EXTERNAL,
            to: new URL(`${location.origin}/spa/authentication/passwordchange`).toString(),
        };
    }
    if (!context.session) {
        return { kind: RouteInterceptor_1.RouteAction.REDIRECT_EXTERNAL, to: redirectUrl };
    }
    return null;
};
exports.authenticationRequired = authenticationRequired;
